import { SizeMax, SizeMin } from "./media";

import { PaddingSize } from "components/organisms/Section";

export const COMMON_SECTION_PADDING = {
  responsives: [
    {
      at: {
        max: SizeMax.Medium,
      },
      value: PaddingSize.S15,
    },
    {
      at: {
        min: SizeMin.Medium,
      },
      value: PaddingSize.S30,
    },
    {
      at: {
        min: SizeMin.ExtraLarge,
      },
      value: PaddingSize.S45,
    },
  ],
};

export const initialFilters = {
  LOAI_2_DAN_ROI: {
    slug: "loai-2-dan-roi",
    pageSize: 12,
    pageNum: 1,
    isHomepage: 1,
  },
  MAY_LOC_KHONG_KHI: {
    slug: "may-loc-khong-khi",
    pageSize: 12,
    pageNum: 1,
    isHomepage: 1,
  },
  LOAI_MULTI: {
    slug: "loai-multi",
    pageSize: 12,
    pageNum: 1,
    isHomepage: 1,
  },
  SKY_AIR: {
    slug: "sky-air",
    pageSize: 12,
    pageNum: 1,
    isHomepage: 1,
  },
};

export const PRODUCT_FEATURE_IMAGE_RATIO = 0.6708595388; // 640 / 954;
export const PRODUCT_TYPES = {
  split: { name: "split" },
  multi: { name: "multi" },
  airPurifier: { name: "airPurifier" },
};

export default {};
